(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsToggle', fbFieldSettingsToggle);

    function fbFieldSettingsToggle() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsToggleCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/settings/toggle'
        };
    }

    function fbFieldSettingsToggleCtrl($scope, FormBuilderService) {
        var vm = this;
        this.$onInit = function() {

            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }
    }
})();